// extracted by mini-css-extract-plugin
module.exports = {"global":"News_global__3O1D9","prevBtn":"News_prevBtn__Mo06_","displayNone":"News_displayNone__3tBfN","inputGroup":"News_inputGroup__UQG3W"};